<template>
  <div class="upload-list">
    <div class="video upload-list__video sm" v-for="item in files" :key="item.id">
      <div class="video-overlay">
        <svgicon name="Delete" class="video-close" @click="$emit('deleteVideo', item)"></svgicon>
        <div class="video-loading" v-if="item.status !== 'uploaded'">
          <div class="video-loading__bar" :style="{'--progress': item.percentage + '%'}"></div>
        </div>
      </div>
      <video :src="item.preview" :poster="item.preview" alt="" v-if="item.preview" muted autoplay></video>
      <img src="../../assets/img/img-processing.png" alt="" v-else>
    </div>
    <!--<div class="upload-list__add">-->

    <!--</div>-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "UploadListFooter",
  data() {
    return {
      progress: 10,
    }
  },
  computed: {
    ...mapGetters({
      files: 'uploadFiles',
    }),
  },
}
</script>

<style lang="scss">

</style>
